export default {
  heroEyebrow: "Hub de ressources Basetao Spreadsheet",
  heroH1: "Basetao Spreadsheet — Trouvez des produits, des vendeurs et des ressources d'achat",
  heroText:
    "Découvrez les ressources Basetao Spreadsheet, les guides de recherche de produits, les informations sur les vendeurs, les conseils QC, les guides d'expédition et des ressources pratiques pour faciliter vos achats en Chine.",
  heroCta1: "Basetao Spreadsheet",
  heroCta2: "Acheter",
  heroTrust: "Ressource indépendante · Recherche pratique · Guides à jour",

  categoriesEyebrow: "Acheter par catégorie",
  categoriesTitle: "Parcourir les produits par catégorie",
  categoriesText:
    "Choisissez une catégorie ci-dessous pour explorer les produits, les vendeurs et les trouvailles du spreadsheet sur le site principal. Chaque lien s'ouvre dans un nouvel onglet.",
  dropdownLabel: "Sélectionner une catégorie",
  dropdownPlaceholder: "Choisir une catégorie…",
  dropdownGo: "Ouvrir",

  aboutEyebrow: "Qu'est-ce que c'est",
  aboutTitle: "Qu'est-ce qu'un Basetao Spreadsheet ?",
  aboutP1:
    "Un Basetao Spreadsheet est une liste ou un tableau partagé par la communauté regroupant des produits, des liens, des notes sur les vendeurs et des observations de contrôle qualité (QC) utilisés par les acheteurs qui commandent via l'agent Basetao. Ces tableaux vous aident à comparer les trouvailles, repérer les vendeurs fiables et rechercher les articles avant d'acheter.",
  aboutP2:
    "Comme un spreadsheet organise des centaines de liens de produits au même endroit, il transforme une recherche lente et dispersée en une méthode plus rapide et structurée pour explorer vêtements, baskets, accessoires et plus.",
  aboutP3:
    "Considérez toujours un spreadsheet comme un point de départ, pas une garantie. Vérifiez vous-même le prix actuel, la note du vendeur et les conditions d'expédition avant de commander.",

  guidesEyebrow: "Guides & articles",
  guidesTitle: "Lisez nos guides originaux",
  guidesText:
    "Des articles indépendants et originaux pour vous aider à rechercher des produits, comprendre le QC et prendre de meilleures décisions.",
  guide1Title: "Basetao Spreadsheet : guide complet du débutant",
  guide1Text:
    "Ce qu'est un Basetao Spreadsheet, comment il fonctionne, les catégories populaires, les conseils QC et les bases de l'expédition — tout ce qu'un débutant doit savoir.",
  guide2Title: "Aperçu des catégories de produits",
  guide2Text:
    "Un tour rapide des principales catégories, des baskets et hoodies aux sacs et accessoires.",
  guide3Title: "Comment lire les photos QC",
  guide3Text:
    "Comprendre les photos QC, les mesures et les signes d'alerte à vérifier avant d'approuver un article.",
  guide4Title: "Les bases de l'expédition",
  guide4Text:
    "Comment le coût d'expédition est estimé, ce qui influence le prix et les facteurs à comparer entre les lignes.",
  readMore: "Lire l'article",

  howEyebrow: "Comment ça marche",
  howTitle: "Recherchez plus intelligemment en quatre étapes",
  step1Title: "Trouver",
  step1Text: "Découvrez produits, vendeurs et ressources au même endroit.",
  step2Title: "Rechercher",
  step2Text: "Comparez les informations sur les produits, les vendeurs et le QC.",
  step3Title: "Vérifier",
  step3Text: "Vérifiez vous-même le prix, l'expédition et les conditions.",
  step4Title: "Décider",
  step4Text: "Commandez avec de meilleures informations et moins de surprises.",

  faqEyebrow: "FAQ",
  faqTitle: "Questions fréquentes",
  faq1Q: "Qu'est-ce qu'un Basetao Spreadsheet ?",
  faq1A:
    "C'est une liste ou un tableau partagé par la communauté regroupant des liens de produits, des notes sur les vendeurs et des observations QC, utilisé par les acheteurs qui commandent via l'agent Basetao.",
  faq2Q: "Est-ce le site officiel de Basetao ?",
  faq2A:
    "Non. Ceci est un site d'information indépendant, non affilié ni approuvé par Basetao.",
  faq3Q: "Comment trouver des produits sur le site principal ?",
  faq3A:
    "Utilisez le menu déroulant ou les boutons de catégorie de cette page. Chaque lien ouvre la catégorie correspondante sur le site principal dans un nouvel onglet.",
  faq4Q: "Combien coûte l'expédition Basetao ?",
  faq4A:
    "Le coût dépend de la destination, du poids, des dimensions et de la méthode d'expédition. Vérifiez toujours les tarifs actuels sur le site principal avant de commander.",
  faq5Q: "Les produits sont-ils garantis ?",
  faq5A:
    "Non. Un spreadsheet ou un lien de produit ne garantit ni l'authenticité, ni la qualité, ni la livraison. Recherchez toujours d'abord les vendeurs et les informations QC.",

  finalCtaTitle: "Commencez avec Basetao Spreadsheet",
  finalCtaText:
    "Explorez les ressources produits, les guides de recherche, les informations QC et les guides d'expédition dans un hub organisé.",
  finalCtaButton: "Explorer Basetao Spreadsheet",
};